import styled from 'styled-components';
import { space } from 'styled-system';

import { Link as VersionedRouterLink } from 'components/RouterLink';

import { linkStyles } from './Link';

export const RouterLink = styled(VersionedRouterLink)`
  ${linkStyles}
  ${space}
`;
